import React from "react";
import SaleTag from "images/buy-now.svg";
import { useAppSelector } from "../../../../../util/store-types";
import { isActiveMembership } from "helpers/membership-helpers";
import { useFlagOrExperiment, flagsAndExperimentNames } from "components/source/hoc/with-flags-and-experiments";

const SubscriptionPromoBanner = () => {
  const activeMember = useAppSelector(state => isActiveMembership(state.membershipState));
  const cmsPromoBanner = useAppSelector(state => state.smartComponentState?.PDPContent?.data?.membership);
  const tabsEnabledFlag = useFlagOrExperiment(flagsAndExperimentNames.RSV_1494_ATB_TABS);

  if (activeMember || Object.keys(cmsPromoBanner ?? {})?.length === 0) {
    return;
  }

  return (
    <div
      className={`h-full p-3 rounded-md text-sm ${
        !tabsEnabledFlag ? "bg-wine100" : "bg-lilac border border-lighterGray shadow-[0px_4px_8px_0px_rgba(0,0,0,0.10)]"
      } `}
      data-test-id="subscription-promo-banner">
      <div className="flex items-center mb-1">
        <SaleTag />
        <p className="ml-2 font-semibold">{cmsPromoBanner?.hed}</p>
      </div>
      <p className="ml-8">{cmsPromoBanner?.copy}</p>
    </div>
  );
};

export default SubscriptionPromoBanner;
